<template>
  <section class="header-menu">
    <div
      class="header-menu__option"
      :class="menuOptionActive == 'stats' ? 'active' : ''"
      @click="clickMenuOption('stats')"
    >
      Estadísticas
    </div>
    <div class="header-menu__option" :class="menuOptionActive == 'mxm' ? 'active' : ''" @click="clickMenuOption('mxm')">
      Jugada a jugada
    </div>
    <div
      class="header-menu__option"
      :class="menuOptionActive == 'lineups' ? 'active' : ''"
      @click="clickMenuOption('lineups')"
    >
      Alineaciones
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  name: 'HeaderMenu',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters('nextGeneral', ['menuOptionActive']),
  },
  watch: {},
  methods: {
    ...mapMutations('nextGeneral', ['setMenuOptionActive']),
    clickMenuOption(option) {
      this.setMenuOptionActive(option);
    },
  },

  async created() {},
};
</script>

<style lang="scss" scoped>
.active {
  background: #2986d8 !important;
}
.header-menu {
  width: 100%;
  height: 45px;
  display: inline-flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 540px) {
    height: 29px;
  }
  &__option {
    width: 33%;
    font-family: 'Avenir-Demi-Medium';
    height: 45px;
    border-radius: 6px;
    background-color: #132739;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 45px;
    letter-spacing: -0.18px;
    text-align: center;
    color: #fff;
    @media screen and (max-width: 540px) {
      height: 29px;
      line-height: 29px;
      font-size: 11px;
    }
    @media screen and (max-width: 319px) {
      font-size: 9px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
